import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-product-cart-delete-dialog',
  imports: [
    MatDialogActions,
    MatDialogContent
  ],
  templateUrl: './product-cart-delete-dialog.html',
  styleUrl: './product-cart-delete-dialog.css'
})
export class ProductCartDeleteDialog {

  constructor(public dialogRef: MatDialogRef<ProductCartDeleteDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  close(): void {
    this.dialogRef.close(false)
  }

  delete(): void {
    this.dialogRef.close(true)
  }
}
